/**
 * Tool Execution Logs API
 */

import { get } from '@aiia/portal-core';

export interface ToolExecutionLog {
  id: string;
  userId: string;
  userToolId: string;
  conversationId?: string;
  toolName: string;
  inputParameters?: Record<string, unknown>;
  webhookUrl?: string;
  httpStatus?: number;
  responseBody?: string;
  success: boolean;
  errorMessage?: string;
  executionTimeMs?: number;
  executedAt: string;
}

export interface PagedResult<T> {
  content: T[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
}

export interface ToolStats {
  toolName: string;
  totalExecutions: number;
  successCount: number;
  failureCount: number;
  avgExecutionTimeMs?: number;
}

export interface ToolExecutionStats {
  totalExecutions: number;
  successCount: number;
  failureCount: number;
  avgExecutionTimeMs?: number;
  byTool: ToolStats[];
}

export const getToolExecutions = (page = 0, size = 20) =>
  get<PagedResult<ToolExecutionLog>>(`/tool-executions?page=${page}&size=${size}`);

export const getToolExecutionsByTool = (toolId: string, page = 0, size = 20) =>
  get<PagedResult<ToolExecutionLog>>(`/tool-executions/tool/${toolId}?page=${page}&size=${size}`);

export const getToolExecutionStats = (period?: string) =>
  get<ToolExecutionStats>(`/tool-executions/stats${period ? `?period=${period}` : ''}`);
